export const mailInfoTo = 'info@acespacecourts.com'
export const mailInfoSubject = 'I am interested in joining AceSpace!'

export const sendEmail = (period: string, plan: string) => {
  window.open(
    `mailto:${mailInfoTo}?subject=${mailInfoSubject}&body=Please send me more information on the ${period} ${plan} package`
  )
}
